
import React from 'react';
import { Headset, TrendingUp, Briefcase, CheckCircle, Headphones, PieChart, ShieldCheck, Zap } from 'lucide-react';

const Solutions: React.FC = () => {
  const sections = [
    {
      id: 'support',
      title: 'Service Client & Support',
      subtitle: 'Gestion des interactions client',
      icon: <Headset className="w-10 h-10" />,
      promise: 'Transformer un pépin en opportunité de fidélisation.',
      details: [
        'Gestion des réclamations & SAV.',
        'Support technique Niveau 1, 2 et 3.',
        'Conciergerie de luxe.',
        'Résolution au premier contact (FCR) priorisée.'
      ],
      image: 'https://images.unsplash.com/photo-1549923746-c502d488b3ea?auto=format&fit=crop&q=80&w=800'
    },
    {
      id: 'acquisition',
      title: 'Acquisition & Vente',
      subtitle: 'Développement commercial stratégique',
      icon: <TrendingUp className="w-10 h-10" />,
      promise: 'Une approche commerciale intelligente, loin du démarchage agressif.',
      details: [
        'Prise de rendez-vous qualifiés (B2B).',
        'Télévente & Upselling.',
        'Enquêtes et sondages.',
        'Techniques de vente consultative.'
      ],
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=800'
    },
    {
      id: 'bpo',
      title: 'BPO & Back-Office',
      subtitle: 'Externalisation des processus métiers',
      icon: <Briefcase className="w-10 h-10" />,
      promise: 'Libérez vos équipes internes des tâches chronophages.',
      details: [
        'Modération de contenu (Réseaux sociaux).',
        'Saisie et traitement de données.',
        'Gestion administrative et comptable.',
        'Workflow optimisé par l\'IA.'
      ],
      image: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&q=80&w=800'
    }
  ];

  return (
    <div className="pt-32 pb-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <header className="mb-24 text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center space-x-2 text-prime-blue font-bold mb-6 text-xs tracking-[0.3em] uppercase">
            <Zap className="w-4 h-4" />
            <span>Nos Expertises</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-prime-dark font-heading mb-8">Une expérience omnicanale sans couture.</h1>
          <p className="text-xl text-slate-500 leading-relaxed font-medium">
            Que ce soit par voix, chat, email ou réseaux sociaux, nous sommes là où vos clients vous attendent avec une agilité technologique de pointe.
          </p>
        </header>

        <div className="space-y-40">
          {sections.map((section, idx) => (
            <div key={section.id} className={`flex flex-col lg:items-center gap-20 ${idx % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'}`}>
              <div className="flex-1 space-y-8">
                <div className="inline-flex p-4 bg-white border border-sand-300 rounded-2xl text-prime-blue shadow-sm">
                  {section.icon}
                </div>
                <div>
                  <p className="text-prime-blue font-bold uppercase tracking-widest text-xs mb-3">{section.subtitle}</p>
                  <h2 className="text-4xl font-bold text-prime-dark font-heading mb-4">{section.title}</h2>
                  <p className="text-lg text-prime-green font-bold italic leading-relaxed">"{section.promise}"</p>
                </div>
                <div className="h-px w-20 bg-sand-300"></div>
                <ul className="grid sm:grid-cols-1 gap-5">
                  {section.details.map((detail, dIdx) => (
                    <li key={dIdx} className="flex items-start text-slate-600 font-medium group">
                      <div className="mt-1 w-5 h-5 rounded-full bg-prime-blue/10 flex items-center justify-center mr-4 shrink-0 transition-colors group-hover:bg-prime-blue group-hover:text-white">
                        <CheckCircle className="w-3 h-3 text-prime-blue group-hover:text-white" />
                      </div>
                      <span className="leading-tight">{detail}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex-1 relative group">
                 <div className="absolute -inset-6 bg-gradient-to-br from-prime-blue/10 to-prime-green/10 rounded-[3rem] blur-2xl group-hover:from-prime-blue/20 group-hover:to-prime-green/20 transition-all duration-700"></div>
                 <div className="relative z-10 overflow-hidden rounded-[3rem] border-8 border-white shadow-2xl">
                   <img 
                    src={section.image} 
                    alt={section.title} 
                    className="w-full h-[500px] object-cover transform group-hover:scale-105 transition-transform duration-1000"
                   />
                   <div className="absolute inset-0 bg-gradient-to-t from-prime-dark/40 to-transparent"></div>
                 </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Solutions;
